export const useSearchHistory = () => {
  const getHistory = () => {
    const geLocaltHistory = localStorage.getItem('PIXEL_HAHA_SSR_SEARCH_HISTORY')
    const localHistory = geLocaltHistory ? JSON.parse(geLocaltHistory).splice(0, 10) : []
    return localHistory
  }

  const setHistory = (val) => {
    let temp = [...getHistory()]
    temp.unshift(picTitleToWhitespace(val))
    temp = Array.from(new Set(temp))
    const arr = temp.splice(0, 10)
    localStorage.setItem('PIXEL_HAHA_SSR_SEARCH_HISTORY', JSON.stringify(arr))
    return arr
  }

  const clearHistory = () => {
    localStorage.setItem('PIXEL_HAHA_SSR_SEARCH_HISTORY', '')
  }


  return {
    getHistory,
    setHistory,
    clearHistory
  }
}
